module.exports = __webpack_public_path__ + "static/img/company-performance-low.a2c5865.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/homepage/company-performance-low.jpg
// module id = TULQ
// module chunks = 0